<template>
  <tr-button
    dropdown="true"
    :label="selectedFilter"
    text-variant="body"
    variant="text"
  >
    <tr-dropdown-item
      key="all"
      :on-item-click="search.bind(undefined, undefined, 'Todos os status')"
    >
      Todos os status
    </tr-dropdown-item>
    <tr-dropdown-item
      v-for="(statusName, statusKey) in billetStatusNamePageFilter"
      :key="statusKey"
      :on-item-click="search.bind(undefined, statusKey, statusName)"
    >
      {{ statusName }}
    </tr-dropdown-item>
  </tr-button>
</template>

<script>
import billetStatusNamePageFilter from '@/apps/payments/payments/billet/constants/billetStatusNamePageFilter';

export default {
  name: 'billet-status-dropdown-filter',
  props: {
    onSearch: {
      required: true,
      type: Function
    }
  },
  data: () => ({
    billetStatusNamePageFilter,
    selectedFilter: 'Todos os status'
  }),
  methods: {
    search(key, name) {
      this.selectedFilter = name;
      this.onSearch(key);
    }
  }
};
</script>
